import { FetchAssertsService } from '@/packages/query-state/shared/services/FetchAssertsService';
import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

import {
  type IAddOfferToComparisonResponse200,
  type IAddOfferToComparisonResponse400,
  type TAddOfferToComparisonRequest,
  type TAddOfferToComparisonResponse_1,
  createAddOfferToComparisonModel,
  fetchAddOfferToComparison,
} from '@/repositories/generated/shared/offers-comparison/v2/add-offer-to-comparison';

export function fetchAddToComparisonService(
  applicationContext: IQueryStateAppContext,
  parameters: TAddOfferToComparisonRequest,
): Promise<TAddOfferToComparisonResponse_1> {
  const { httpApi, logger } = applicationContext;

  const fetchAssertsService = new FetchAssertsService(
    createAddOfferToComparisonModel(parameters),
    '@/shared/store/serverSide/comparison/v1/add-to-comparison/internal/fetchService.ts',
    logger,
  );

  return fetchAddOfferToComparison<IAddOfferToComparisonResponse200, IAddOfferToComparisonResponse400>({
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400:
          throw fetchAssertsService.assert400StatusCodeError(result);
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
